import moment from 'moment-timezone';

/**
 * Parses an `"HH:MM"` lock-time string into a Date with the given hour/minute
 * applied to today. Falls back to `defaultHour:00` when the input is empty
 * or invalid.
 */
export const lockTimeToDate = (
  input: string | null | undefined,
  defaultHour: number,
): Date => {
  const [hour, minute] = input ? input.split(':').map((n) => Number(n)) : [defaultHour, 0];

  return moment()
    .set({
      hour,
      minute,
    })
    .toDate();
};

/**
 * Parses an `"HH:MM"` lock-time string into the number of minutes since
 * midnight. Returns `null` when the input is missing or cannot be parsed.
 */
export const lockTimeToMinutes = (input: string | null | undefined): number | null => {
  if (!input) return null;
  const [hour, minute] = input.split(':').map((n) => Number(n));
  if (Number.isNaN(hour) || Number.isNaN(minute)) return null;
  return hour * 60 + minute;
};
